import { useLocationModules } from '@hooks/location-module/location-module.hooks'
import { useSessionStore } from '@hooks/use_session_store'
import { Navigate, useSearchParams } from 'react-router-dom'
import { getAuthRouteToNavigate } from './routes.components'

const RootComponent = () => {
  const { isLoggedIn, logout } = useSessionStore()
  const [params] = useSearchParams()
  const routeUid = params.get('uid')

  const isImpersonating = routeUid !== null && routeUid !== undefined && routeUid !== ''
  if (isImpersonating) {
    if (isLoggedIn) {
      logout()
    }

    return <Navigate to={`/login?uid=${routeUid}`} />
  }

  if (isLoggedIn) {
    const { data: enabledModulesData } = useLocationModules()
    const authRouteToNavigate = getAuthRouteToNavigate(enabledModulesData?.enabledModules ?? [])
    return <Navigate to={authRouteToNavigate} />
  }
  return <Navigate to='/login' />
}

export const root = {
  path: '/',
  element: <RootComponent />,
}
